/** Infra API del módulo Compras — repos, queries, pull local/remoto.
 * Depende de domain-api. Importar desde acá para evitar require cycles. */

// purchasesPullLocal
export { applyPurchasesPullLocal } from './infra/purchasesPullLocal';

// purchasesPullRemote
export { pullBranchPurchasesRemote } from './infra/purchasesPullRemote';
export type { PurchasesPullPayload } from './infra/purchasesPullRemote';

// purchasesRepoRead
export {
  listPurchaseOrdersForBranch,
  countPurchaseOrdersForBranch,
  getPurchaseOrderById,
  listPurchaseOrderItems,
  listReceptionsForBranch,
  getReceptionById,
  listReceptionsForOrder,
  listReturnsForBranch,
  findDuplicateSupplierInvoiceRef,
  hasActiveReturnForOrder,
  summarizePurchasesForBranch,
} from './infra/purchasesRepoRead';

// purchasesRepoSupplierAccount
export {
  getSupplierAccountSummary,
  listSuppliersWithPurchases,
  type SupplierAccountSummary,
  type SupplierAccountEntry,
} from './infra/purchasesRepoSupplierAccount';

// purchasesRepoMutations (types only)
export type {
  CreatePurchaseOrderInput,
  CreatePurchaseOrderResult,
  VoidPurchaseOrderInput,
  ClosePurchaseOrderInput,
  CreatePurchaseReceptionInput,
  CreatePurchaseReceptionResult,
  CreateReceptionItemInput,
  VoidPurchaseReceptionInput,
  CreatePurchaseReturnInput,
  CreatePurchaseReturnResult,
  VoidPurchaseReturnInput,
} from './infra/purchasesRepoMutations';
